import { restGet, restPost } from "../../apiCommandsExecutor/rest";
import { ItemBadge, MenuCategory, MenuInfoPublic, MenuItem, MenuItemModifierSet, MenuWithQuantitiesPublic, StaffCallKind, Table } from "./models";

export interface PublicMenuRest {
    menu: MenuWithQuantitiesPublic;
    menuCategories: MenuCategory[];
    menuItemsByCategoryId: { [categoryId: string]: MenuItem[] };
    menuItemModifierSetsById: { [modifierSetId: string]: MenuItemModifierSet };
    menuItemBadgesById: { [badgeId: string]: ItemBadge };
    tables: Table[];
}

class MenuRestService {
    static async getMenu(menuId: number) {
        return restGet<PublicMenuRest>(`/menus/${menuId}`);
    }

    static async getMenuInfo(menuId: number) {
        return restGet<MenuInfoPublic>(`/menus/${menuId}/info`);
    }

    // Путь исторический: по нему же приходят вызовы из вкладок, открытых до вызова персонала.
    static async callStaff(menuId: number, tableId: number, kind: StaffCallKind) {
        return restPost<null>(`/menus/${menuId}/waiter-calls`, { tableId, kind });
    }
}

export default MenuRestService;
